<template>
	<v-container
		fluid
		class="d-flex px-0 justify-space-around flex-wrap flex-md-nowrap flex-lg-nowrap"
		style="gap: 5px"
	>
		<v-card class="rounded-xl" elevation="0" outlined width="100%">
			<v-card-title
				><v-container class="text-center green--text py-0"
					>Credit</v-container
				>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="3">
						<div class="text-md-h6">$</div>
						<div class="text-md-h6">VN</div>
					</v-col>
					<v-col class="text-right"
						><div class="text-md-h6">
							{{ convertToCleanNumber(credits.dollarCredit) }}
						</div>
						<div class="text-md-h6">
							{{
								convertToCleanNumber(credits.dongCredit, false)
							}}
						</div></v-col
					>
				</v-row>
			</v-card-text>
		</v-card>
		<v-card class="rounded-xl" elevation="0" outlined width="100%">
			<v-card-title
				><v-container class="text-center red--text py-0"
					>Pending<span class="ml-1"
						>({{ overview.pending }})</span
					></v-container
				>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="3">
						<div class="text-md-h6">$</div>
						<div class="text-md-h6">VN</div>
					</v-col>
					<v-col class="text-right"
						><div class="text-md-h6">
							{{ convertToCleanNumber(overview.usPendingAmount) }}
						</div>
						<div class="text-md-h6">
							{{
								convertToCleanNumber(
									overview.vnPendingAmount,
									false
								)
							}}
						</div></v-col
					>
				</v-row>
			</v-card-text>
		</v-card>

		<v-card class="rounded-xl" elevation="0" outlined width="100%">
			<v-card-title
				><v-container class="text-center py-0 green--text"
					>Paid<span class="ml-1"
						>({{ overview.paid }})</span
					></v-container
				>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="3">
						<div class="text-md-h6">$</div>
						<div class="text-md-h6">VN</div>
					</v-col>
					<v-col class="text-right"
						><div class="text-md-h6">
							{{ convertToCleanNumber(overview.usPaidAmount) }}
						</div>
						<div class="text-md-h6">
							{{
								convertToCleanNumber(
									overview.vnPaidAmount,
									false
								)
							}}
						</div></v-col
					>
				</v-row>
			</v-card-text>
		</v-card>
		<v-card class="rounded-xl" elevation="0" outlined width="100%">
			<v-card-title
				><v-container class="text-center py-0 primary--text"
					>Total of Invoices</v-container
				>
			</v-card-title>
			<v-card-text class="text-center text-h3">{{
				overview.totalInvoice
			}}</v-card-text>
		</v-card>

		<v-card class="rounded-xl" elevation="0" outlined width="100%">
			<v-card-title
				><v-container class="text-center py-0 primary--text"
					>Total of Orders</v-container
				>
			</v-card-title>
			<v-card-text class="text-center text-h3">{{
				orderOverview.totalOrder
			}}</v-card-text>
		</v-card>
	</v-container>
</template>
<script>
import { CurrencyType, PaymentStatus } from '@/js/enum';
export default {
	name: 'DashboardOverview',
	components: {},
	props: {
		credits: {
			type: Object,
			default: () => {
				return { dollarCredit: 0, dongCredit: 0 };
			},
		},
		invoices: {
			type: Array,
			default: () => {
				return [];
			},
		},
		shipments: {
			type: Array,
			default: () => {
				return [];
			},
		},
		orders: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	computed: {
		overview() {
			let overview = {};
			let usPendingAmount = 0;
			let vnPendingAmount = 0;
			let usPaidAmount = 0;
			let vnPaidAmount = 0;
			let pending = 0;
			let paid = 0;
			let totalInvoice = 0;
			for (let i = 0; i < this.invoices.length; i++) {
				let invoice = this.invoices[i];
				totalInvoice++;
				if (
					invoice.currencyId ==
					this.enumToOption[CurrencyType.UsDollar].id
				) {
					if (
						invoice.paymentStatusId ==
						this.enumToOption[PaymentStatus.Paid].id
					) {
						usPaidAmount += invoice.totalAmount;
						paid++;
					} else if (
						invoice.paymentStatusId ==
						this.enumToOption[PaymentStatus.PartiallyPaid].id
					) {
						usPaidAmount += invoice.amountPaid + invoice.creditPaid;
						usPendingAmount +=
							invoice.totalAmount -
							(invoice.amountPaid + invoice.creditPaid);
						pending++;
					} else {
						usPendingAmount += invoice.totalAmount;
						pending++;
					}
				} else if (
					invoice.currencyId ==
					this.enumToOption[CurrencyType.VietDong].id
				) {
					if (
						invoice.paymentStatusId ==
						this.enumToOption[PaymentStatus.Paid].id
					) {
						vnPaidAmount += invoice.totalAmount;
						paid++;
					} else if (
						invoice.paymentStatusId ==
						this.enumToOption[PaymentStatus.PartiallyPaid].id
					) {
						vnPaidAmount += invoice.amountPaid + invoice.creditPaid;
						vnPendingAmount +=
							invoice.totalAmount -
							(invoice.amountPaid + invoice.creditPaid);
						pending++;
					} else {
						vnPendingAmount += invoice.totalAmount;
						pending++;
					}
				}
			}
			overview = {
				usPendingAmount,
				usPaidAmount,
				vnPaidAmount,
				vnPendingAmount,
				paid,
				pending,
				totalInvoice,
			};
			return overview;
		},
		orderOverview() {
			let orderOverview = {};
			let totalOrder = this.orders.length;
			orderOverview = {
				totalOrder,
			};
			return orderOverview;
		},
		enumToOption() {
			return this.$store.getters['enumToOption'];
		},
	},
	methods: {
		convertToCleanNumber(val) {
			if (!val) return '0.00';
			let typeStr = typeof val;
			if (typeStr === 'object') val = val.toNumber();
			return val.toLocaleString('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		},
		getCurrencySymbol(id) {
			let us = this.getIdByEnum(CurrencyType.UsDollar);
			let viet = this.getIdByEnum(CurrencyType.VietDong);
			if (id == us) {
				return '$';
			} else if (id == viet) {
				return '₫';
			}
			return '';
		},
	},
};
</script>
